import { userPageNoteApi } from 'api'

const state = {
  notes: []
}

const getters = {
  notes: state => state.notes
}

const actions = {
  getNotes ({ commit }) {
    userPageNoteApi.getList().then(resp => {
      commit('setNotes', resp.data)
    })
  },
  addNote ({ commit }, note) {
    userPageNoteApi.add(note.pageNumber, note.note).then(resp => {
      commit('addNote', resp.data)
    })
  },
  deleteNote ({ commit }, id) {
    userPageNoteApi.delete(id).then(resp => {
      commit('deleteNote', id)
    })
  }
}

const mutations = {
  setNotes (state, notes) {
    state.notes = notes
  },
  addNote (state, note) {
    state.notes.push(note)
  },
  deleteNote (state, id) {
    state.notes.splice(state.notes.findIndex(n => n.id === id), 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
